var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlazon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.07453V5.77562C18.5 10.0052 15.6488 13.7312 11.5021 14.8958C11.5014 14.8959 11.5008 14.896 11.5001 14.896C11.4994 14.896 11.4986 14.896 11.4979 14.8958C9.48004 14.3285 7.70637 13.1305 6.44434 11.4848C5.18235 9.83913 4.5003 7.83498 4.5 5.77562C4.5 5.7756 4.5 5.77558 4.5 5.77555V5.07453L11.4969 1.14116C11.4969 1.14116 11.4969 1.14116 11.497 1.14116C11.4974 1.14092 11.4985 1.1405 11.5 1.1405C11.5015 1.1405 11.5026 1.14093 11.5031 1.14116L18.5 5.07453ZM10.755 11.5642L11.1432 11.8825L11.46 11.4929L15.778 6.18154L16.0984 5.78738L15.6992 5.47322L14.9192 4.85935L14.5326 4.55507L14.2221 4.93674L10.8568 9.07374L8.63697 7.25416L8.25647 6.94228L7.93848 7.31767L7.29848 8.07321L6.97008 8.4609L7.36298 8.78304L10.755 11.5642Z",
    fill: "#00AF3B",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 8.01883,
    rx: 5.5,
    ry: 4.91885,
    fill: "#00AF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8328 4.57556L11.1672 9.53745L9 7.31399L8 8.04013L11.3328 11.462L16 5.3017L14.8328 4.57556Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0.640503,
    width: 23,
    height: 22.7555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlazon);
export default __webpack_public_path__ + "static/media/blazon.7e8ee11f7d56f350e3215baeae2a3702.svg";
export { ForwardRef as ReactComponent };